import { render } from "./CrewListActions.vue?vue&type=template&id=15f7aee4"
import script from "./CrewListActions.vue?vue&type=script&lang=js"
export * from "./CrewListActions.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__